import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared';
import { UIRouterModule } from '@uirouter/angular';
import { EntityDataService } from '@ngrx/data';
import { entityName } from '../data-services/rate-ceiling/rate-ceiling.data-service';
//import { TaskTimerDataService } from '../data-services/task-timer';
import { TaskTimerRoute } from './task-timer.route';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as reducer from './store/task-timer.reducer';
import * as histreducer from './store/timer-history/task-timer-history.reducer';
import { TaskTimerEffects } from './store/task-timer.effects';
import { TaskTimerHistoryEffects } from './store/timer-history/task-timer-history.effects';

@NgModule({
    providers: [
        //TaskTimerDataService
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [TaskTimerRoute]
        }),
        StoreModule.forFeature(reducer.taskTimersFeatureKey, reducer.reducer),
        StoreModule.forFeature(
            histreducer.TaskTimerHistorysFeatureKey,
            histreducer.reducer
        ),
        EffectsModule.forFeature([TaskTimerEffects, TaskTimerHistoryEffects])
    ]
})
export class TaskTimerModule {
    constructor(
        entityDataService: EntityDataService
        //taskTimerService: TaskTimerDataService
    ) {
        //entityDataService.registerService(entityName, taskTimerService);
    }
}
